import React from 'react';
import { RCFormGroup } from '../RCFormGroup';
import type { FormattedString, TagType } from '../../types';
import { RadioCardImpl } from './RadioCardImpl';

export interface GroupProps {
  /** All children must be RCRadioCardGroup.Option */
  children: React.ReactElement<OptionProps>[];

  /** Main label text (or more complex components if you really need to) */
  label: FormattedString;

  /** ID of the input component, must be unique across the page */
  id: string;

  /** html attr, used by html form submission */
  name: string;

  /** current value */
  value: string;

  /** called when value changes; updated value in evt.target.value */
  onChange: React.ChangeEventHandler<HTMLInputElement>;

  /** Signals to browser's form validator that a non-empty value must be selected */
  required?: boolean; // TODO this is passed anywhere

  /** Validation error message */
  errorText?: string;
  /** Additional info displayed below label */
  helpText?: FormattedString;
  /** Annotation on the field, e.g. 'required', 'optional' */
  tag?: TagType;
}

export interface OptionProps {
  label: FormattedString;
  sublabel?: string;
  value: string;
  disabled?: boolean;
  /** Additional card content below label and sublabel */
  children?: React.ReactNode;
}

function Option(_props: OptionProps) {
  // Non-rendering component, output is generated by parent RadioGroup
  return null;
}

/**
 * Wraps a set of radio options. Children must be `<Option>`s
 */
export function RCRadioCardGroup(props: GroupProps) {
  return (
    <RCFormGroup
      errorText={props.errorText}
      helpText={props.helpText}
      inputId={props.id}
      label={props.label}
      tag={props.tag}
    >
      <div className="rc-radio-card-group">
        {props.children.filter(Boolean).map(({ props: option }) => (
          // Iterate over <Option> children and render actual implementations
          <RadioCardImpl
            key={option.value}
            id={`${props.id}--${option.value}`}
            name={props.name}
            label={option.label}
            sublabel={option.sublabel}
            value={option.value}
            disabled={option.disabled}
            checked={props.value === option.value}
            onChange={props.onChange}
          >
            {option.children}
          </RadioCardImpl>
        ))}
      </div>
    </RCFormGroup>
  );
}

RCRadioCardGroup.Option = Option;
